/*=========================================================================================
  File Name: module-customsdeclaration-state.js
  Description: Customs Declaration Module State
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: DQDUY
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	CustomsDeclaration: [],
	CustomsDeclarationTotal: 0,
	IsLoadingTotalRecords: false,
	// State quản lý selection cho bulk actions
	selectedDeclarations: []
};
